import { forwardRef, useCallback, useImperativeHandle, useMemo, useState } from "react";
import { P2Modal } from "react-bootstrap-common-script";
import RadioGroup from "../../../components/form/grouped/radio/radio-group";
import { RadioItemInterface } from "../../../models/interfaces/radio-item.interface";
import { useAppSelector } from "../../../redux/hook";
import useIsMobile from "../../../hooks/use-is-mobile";
import { Owner } from "../../../models/polymer/Owner.model";

export interface RegistrarSelectionModalHandle {
  items: RadioItemInterface[];
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

interface RegistrarSelectionModalProps {
  outgoingOwnerRepresented: Owner | undefined;
  currentOwners: Owner[];
  setOutgoingOwnerRepresented: (value: Owner) => void;
  handleSubmit: () => void;
}

const RegistrarSelectionModal = forwardRef<RegistrarSelectionModalHandle, RegistrarSelectionModalProps>(function RegistrarSelectionModal(
  { outgoingOwnerRepresented, currentOwners, setOutgoingOwnerRepresented, handleSubmit },
  ref
) {
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const { isMobile } = useIsMobile();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { owners, radioItems } = useMemo(() => {
    const owners: Owner[] = currentOwners;
    const radioItems: RadioItemInterface[] = currentOwners.filter(item => item.myinfo.uinfin !== loginUser.uinfin).map((item, index) => {
      return {
        id: index,
        value: item.myinfo.uinfin,
        description: item.myinfo.name,
        variant: "default",
      }
    })
    return { owners, radioItems };
  }, [currentOwners, loginUser.uinfin]);

  const handleSelect = useCallback(
    (uinfin: string) => {
      const targetOwner = owners.find((owner) => owner.myinfo.uinfin === uinfin);

      if (!targetOwner) return;

      setOutgoingOwnerRepresented(targetOwner);
    },
    [owners, setOutgoingOwnerRepresented]
  );

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  useImperativeHandle(ref, () => {
    return {
      items: radioItems,
      isOpen,
      setIsOpen,
    };
  });

  return (
    <P2Modal
      isOpen={isOpen}
      onCloseModal={handleClose}
      variant="default"
      title={`Please select which outgoing owners is represented by Registrar`}
      primaryButtonText="Back"
      secondaryButtonText="Proceed"
      primaryButtonFunction={handleClose}
      secondaryButtonFunction={handleSubmit}
      secondaryButtonDisabled={!outgoingOwnerRepresented}
      children={
        <div style={{ paddingTop: 24, paddingBottom: 24, ...(!isMobile && { width: 650 }) }}>
          <RadioGroup
            r2Enabled={true}
            gap={8}
            layout="default"
            items={radioItems}
            value={outgoingOwnerRepresented?.myinfo.uinfin}
            disabled={false}
            onItemSelect={handleSelect}
          />
        </div>
      }
    />
  );
});

export { RegistrarSelectionModal };
